import styled, { css } from "styled-components";

import { Text } from "@ui/Atoms/Text";

import { TitleStyledProps } from "./Title.types";

export const Title = styled(Text).attrs({
  as: "h2",
  $style: "semibold_24",
})<TitleStyledProps>`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.spacing_24};

  ${({ modalVariant, direction, theme }) =>
    modalVariant === "icon" &&
    css`
      align-items: center;

      ${theme.breakpoints.desktop} {
        ${direction === "horizontal" &&
        css`
          flex-direction: row;
          align-items: flex-start;
          gap: ${theme.spacing.spacing_16};
        `}
      }
    `}
`;
